import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Reveal from "./Reveal";
import { FAQS } from "../content";

function Item({ faq, index, open, onToggle }) {
  return (
    <div className="border-b-2 border-ink" data-testid={`faq-item-${index}`}>
      <button
        data-testid={`faq-trigger-${index}`}
        onClick={onToggle}
        aria-expanded={open}
        className="flex w-full items-center justify-between gap-6 py-6 text-left transition-colors duration-200 hover:bg-pastel-mint/30"
      >
        <span className="font-display text-xl font-extrabold tracking-tight text-ink md:text-2xl">
          {faq.q}
        </span>
        <motion.span
          animate={{ rotate: open ? 45 : 0 }}
          transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
          className="relative h-9 w-9 shrink-0 rounded-lg border-2 border-ink bg-white shadow-chunk"
        >
          <span className="absolute left-1/2 top-1/2 h-px w-3.5 -translate-x-1/2 -translate-y-1/2 bg-ink" />
          <span className="absolute left-1/2 top-1/2 h-3.5 w-px -translate-x-1/2 -translate-y-1/2 bg-ink" />
        </motion.span>
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
            className="overflow-hidden"
          >
            <p className="max-w-2xl pb-7 text-base leading-relaxed text-ink/70">
              {faq.a}
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="py-24 md:py-36">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 px-6 md:px-16 lg:grid-cols-12">
        <Reveal className="lg:col-span-5">
          <h2 className="font-display text-4xl font-extrabold leading-[1.02] tracking-tight text-ink md:text-6xl">
            Before you
            <br />
            download.
          </h2>
          <p className="mt-6 max-w-xs text-base leading-relaxed text-ink/70">
            The honest answers to what artists ask us most.
          </p>
        </Reveal>
        <div className="border-t-2 border-ink lg:col-span-7">
          {FAQS.map((faq, i) => (
            <Item
              key={faq.q}
              faq={faq}
              index={i}
              open={open === i}
              onToggle={() => setOpen(open === i ? -1 : i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
